import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAllAccountApi = (params) => api.get(`admin/getall-vertex-account?${qs(params)}`);
export const AccountRequestAcceptRejectApi = (data) => api.post('admin/vertex-account-approve-reject', data);
export const GetAllV2fxAccountByIdApi = (terminalID) => api.get(`trading/get-account-byid/${terminalID}`);